import Joi from 'joi';
import {getSchema} from '../AutoSection';

const validateForm = (fields, data, sanitize = true) => {
    if (data && fields) {
        const dataCopy = JSON.parse(JSON.stringify(data));
        const allFields = Object.keys(fields);
        const schema = getSchema(allFields, fields);
        const processedData = dataCopy;
        if (sanitize) {
            Object.keys(processedData).forEach(key => {
                if (!allFields.includes(key)) {
                    delete processedData[key];
                }
            });
        }
        return Joi.object(schema).validate(processedData, {abortEarly: false});
    } else {
        return {};
    }
};

export default validateForm;
